import '../../Styles/App.css';
import { Link } from 'react-router-dom';
import { Typography, Box } from '@mui/material';

function ProjectButton(props) {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
                minWidth: 0,
            }}
        >
            <Link
                to={props.ProjectLink}
                style={{
                    textDecoration: 'none',
                    height: '100%',
                    display: 'block',
                    minWidth: 0,
                }}
                onClick={() => window.scrollTo({ top: 0, behavior: 'instant' })}
            >
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        height: '100%',
                        minWidth: 0,
                    }}
                >
                    <Box
                        sx={{
                            position: 'relative',
                            borderRadius: '16px',
                            background:
                                'linear-gradient(180deg, rgba(255,255,255,0.04) 0%, rgba(255,255,255,0.02) 100%)',
                            border: '1px solid rgba(255,255,255,0.08)',
                            boxShadow: `
                                0 0 0 1px rgba(255,255,255,0.03) inset,
                                0 10px 30px rgba(0,0,0,0.28)
                            `,
                            mb: 1.25,
                            transform: 'translateY(0)',
                            transition: 'transform 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease',

                            '&:hover': {
                                transform: 'translateY(-4px)',
                                borderColor: 'rgba(255,255,255,0.14)',
                                boxShadow: `
                                    0 0 0 1px rgba(255,255,255,0.05) inset,
                                    0 18px 40px rgba(0,0,0,0.42)
                                `,
                            },

                            '&:hover .project-overlay': {
                                opacity: 1,
                            },

                            '&:hover .project-image': {
                                transform: 'scale(1.02)',
                            },
                        }}
                    >
                        <Box
                            sx={{
                                position: 'relative',
                                borderRadius: 'inherit',
                                overflow: 'hidden',
                                width: '100%',
                                lineHeight: 0,
                            }}
                        >
                            <Box
                                component="img"
                                className="project-image"
                                src={props.ProjectImageSRC}
                                alt={props.ProjectTitle}
                                sx={{
                                    width: '100%',
                                    height: 'auto',
                                    aspectRatio: '16 / 9',
                                    objectFit: 'cover',
                                    display: 'block',
                                    transition: 'transform 0.4s ease',
                                    transformOrigin: 'center center',
                                    willChange: 'transform',
                                    backfaceVisibility: 'hidden',
                                }}
                            />

                            <Box
                                className="project-overlay"
                                sx={{
                                    position: 'absolute',
                                    inset: 0,
                                    display: 'flex',
                                    alignItems: 'flex-end',
                                    p: 2,
                                    opacity: 0,
                                    transition: 'opacity 0.3s ease',
                                    background:
                                        'linear-gradient(to top, rgba(0,0,0,0.82) 0%, rgba(0,0,0,0.42) 42%, rgba(0,0,0,0.08) 100%)',
                                }}
                            >
                                <Typography
                                    variant="h6"
                                    sx={{
                                        color: 'white',
                                        fontWeight: 700,
                                    }}
                                >
                                    {props.ProjectTitle}
                                </Typography>
                            </Box>
                        </Box>
                    </Box>

                    <Typography
                        variant="subtitle1"
                        sx={{
                            color: 'white',
                            fontWeight: 600,
                            lineHeight: 1.2,
                            mb: 0.5,
                        }}
                    >
                        {props.ProjectTitle}
                    </Typography>

                    <Typography
                        variant="body2"
                        sx={{
                            color: 'rgba(255,255,255,0.7)',
                            lineHeight: 1.4,
                            display: '-webkit-box',
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: 'vertical',
                            overflow: 'hidden',
                        }}
                    >
                        {props.ProjectDesc}
                    </Typography>
                </Box>
            </Link>
        </Box>
    );
}

export default ProjectButton;